import { Theme as themeType } from './types';
import defaultThemeImp from './defaultTheme';
import * as styledComponents from 'styled-components';

export type Theme = themeType;
export const defaultTheme = defaultThemeImp;

export const getTheme = (): Theme => {
	return defaultTheme;
};

const {
	default: styled,
	css,
	keyframes,
	ThemeProvider,
	createGlobalStyle,
} = styledComponents as styledComponents.ThemedStyledComponentsModule<Theme>;

export { styled, css, keyframes, ThemeProvider, createGlobalStyle };
